import { Helmet, history, useModel } from '@umijs/max';
import { List, PullRefresh, Image, Cell } from 'react-vant';
import { useRef, useState } from 'react';
import NoData from '@/components/NoData';
import { getWechatAboutPage } from '@/service/banner';
import styles from './index.less'

const AboutProperty = () => {
  const [finished, setFinished] = useState<boolean>(false);
  const [aboutPropertyList, setAboutPropertyList] = useState<any[]>([]);
  const pageNum  = useRef(1);
  const { defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );
 
  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setAboutPropertyList([])

    const data = await getWechatAboutPage({ pageNum: pageNum.current, pageSize: 10, status: '1',  communityId: defaultRoom?.communityId })
    const listData: any =  [...aboutPropertyList, ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setAboutPropertyList(data.rows); 
    } else {
      setAboutPropertyList(listData);
    }
 
    
    // console.log(listData, data)
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1
      setFinished(false); // 仍有数据可加载，保持为false
    }
  }

  const onRefresh = async () => {
    pageNum.current = 1
    setFinished(true)
    setAboutPropertyList([])
    onLoadRefresh(true)
  }

  const viewDatail = (item: any) => {
    history.push(`/aboutPropertyDetail?sequenceNbr=${item.sequenceNbr}`);
  }

  return (
    <div>
      <Helmet>
        <title>关于物业</title>
      </Helmet>
      
        <PullRefresh onRefresh={onRefresh} >
        <List finished={finished} onLoad={onLoadRefresh} finishedText={!aboutPropertyList ?.length ? '' : '没有更多了'} >
          {aboutPropertyList.length ? <> {aboutPropertyList.map((item) => (
                <div key={item.sequenceNbr} className={styles.container}>
                  <div className={styles.containerItem} onClick={() => viewDatail(item)}>
                    <Image width='100%' height='100' className={styles.imgBox} fit='cover' src={item.image} />
                    <div className={styles.titles}> 
                      <Cell
                        center
                        title={item.title}
                        label=''
                        value='查看详情'
                        isLink
                      /></div>
                  </div>
                  
                </div>
              ))}
              </>
              : (
                finished && <NoData />
              )}
          </List>
          
        </PullRefresh>
       
    </div>
  );
};

export default AboutProperty;
